/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum CustomerPriceTypeApiModel {
  Currency = 'currency',

  RetailSpecialAccount = 'retail-special-account',

  RetailSpecialAccountAccess = 'retail-special-account-access',

  CorporateSpecialAccount = 'corporate-special-account',

  CorporateSpecialAccountAccess = 'corporate-special-account-access'
}
